import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { CompanyCard } from "../components/CompanyCard";
import { useLang } from "../context/LanguageContext";
import { TERMS } from "../content/termsContent";

const HERO_IMG = "https://static.prod-images.emergentagent.com/jobs/aac30769-f491-4e91-84b6-42abbea5b108/images/480ed47abb8837de4d45868c027f49c82d0159dab0458873a2209c646b6a7ef8.jpeg";

export default function Terms() {
  const { lang } = useLang();
  const tc = TERMS[lang] || TERMS.sk;
  return (
    <div data-testid="terms-page">
      <PageHero overline={tc.overline} title={tc.title} subtitle={tc.updated} image={HERO_IMG} />
      <section className="relative z-10 py-20 md:py-28 bg-[#050505]">
        <div className="max-w-3xl mx-auto px-6 space-y-10">
          {tc.sections.map((s, i) => (
            <Reveal key={i} delay={i * 0.03}>
              <div data-testid={`terms-section-${i + 1}`}>
                <h2 className="font-display text-2xl md:text-3xl mb-3 text-[#F2E3C6]">{s.heading}</h2>
                <p className="text-white/60 leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          ))}
          <Reveal><div className="mt-16"><CompanyCard /></div></Reveal>
        </div>
      </section>
    </div>
  );
}
